import {animate, style, transition, trigger} from '@angular/animations';
import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {NgbTimeStruct} from '@ng-bootstrap/ng-bootstrap';
import {
  ComparisonOperator,
  CullAtomDTO,
  CullWithAtomsDTO,
  DateTimePart,
  DateTimePartCullAtomDTO, TimeCullAtomDTO, TimeRangeCullAtomDTO
} from '../../../services/api/api';
import {SbLocalTime} from '../../../services/api/api-date-time';
import {ModalService} from '../../../services/gui/modal/modal.service';

@Component({
  selector: 'sb-filter-time-cull',
  templateUrl: './sb-filter-time-cull.component.html',
  styleUrls: ['./sb-filter-time-cull.component.scss'],
  animations: [
    trigger('slideInOut', [
      transition(':enter', [style({ transform: 'translateX(-100%)' }), animate('200ms ease-in', style({ transform: 'translateX(0%)' }))]),
      transition(':leave', [animate('200ms ease-in', style({ transform: 'translateX(+100%)' }))]),
    ]),
  ],
  standalone: false,
})
export class SbFilterTimeCullComponent implements OnInit {
  @Input() cull: CullWithAtomsDTO;

  @Output() cullChange: EventEmitter<CullWithAtomsDTO> = new EventEmitter<CullWithAtomsDTO>();

  easyModeRows: EasyModeRow[];
  expression = '';
  initialBeginTimeStruct: NgbTimeStruct = { hour: 0, minute: 0, second: 0 };
  initialEndTimeStruct: NgbTimeStruct = { hour: 23, minute: 59, second: 59 };

  @Input()
  easyMode: boolean;

  @Input()
  disabled: boolean = false;

  constructor(private modalService: ModalService) {}

  ngOnInit(): void {
    if (this.cull.atoms && this.cull.atoms.length && this.easyMode) {
      const easyModeRowCounter = this.cull.atoms.length / 3;

      const easyModeRows: EasyModeRow[] = [];

      for (let i = 0; i < easyModeRowCounter; i++) {
        let value: any;
        const r: EasyModeRow = new EasyModeRow();
        value = this.cull.atoms[3 * i] as DateTimePartCullAtomDTO;
        r.from = value.partValue.toString();

        value = this.cull.atoms[1 + 3 * i] as DateTimePartCullAtomDTO;
        r.till = value.partValue.toString();

        value = this.cull.atoms[2 + 3 * i] as TimeRangeCullAtomDTO;
        if (value.operator === ComparisonOperator.In) {
          r.fromTime = value.start.value;
          r.tillTime = value.end.value;
        } else {
          r.fromTime = value.end.value;
          r.tillTime = value.start.value;
        }
        easyModeRows.push(r);
      }
      this.easyModeRows = easyModeRows;
    } else if (this.easyMode) {
      this.easyModeRows = [new EasyModeRow()];
      this.easyModeRows[0].from = '1';
      this.easyModeRows[0].till = '7';
      this.easyModeRows[0].fromTime = { ...this.initialBeginTimeStruct };
      this.easyModeRows[0].tillTime = { ...this.initialEndTimeStruct };
      this.updateDTO();
    }
  }

  addRow() {
    const row = new EasyModeRow();
    row.from = '1';
    row.till = '7';
    row.fromTime = { ...this.initialBeginTimeStruct };
    row.tillTime = { ...this.initialBeginTimeStruct };
    this.easyModeRows.push(row);
    this.updateDTO();
  }

  removeRow(index) {
    this.easyModeRows.splice(index, 1);
    this.updateDTO();
  }

  rowChanged(r: EasyModeRow) {
    this.updateDTO();
  }

  emitChange(cull?: CullWithAtomsDTO) {
    this.cullChange.emit(cull ? cull : this.cull);
  }

  updateDTO() {
    const atoms: CullAtomDTO[] = [];
    let numCounter = 1;
    let expression = '';
    let i = 0;
    for (const r of this.easyModeRows) {
      const rowAtoms = this.rowToAtomDTOs(r);
      if (rowAtoms && rowAtoms.length) {
        if (i !== 0) {
          expression += '|';
        }
        let k = 0;
        let rowExpression = '(';

        for (const a of rowAtoms) {
          a.id = { num: numCounter++, cull: { id: this.cull ? this.cull.id : null } };
          rowExpression += a.id.num;
          if (k !== 2) {
            rowExpression += '&';
          }
          k++;
        }

        rowExpression += ')';

        expression += rowExpression;

        for (const row of rowAtoms) {
          atoms.push(row);
        }
      }
      i++;
    }

    this.cull.atoms = atoms;
    this.cull.expression = expression;

    this.emitChange();
  }

  rowToAtomDTOs(r: EasyModeRow): TimeCullAtomDTO[] {
    if (!r.fromTime || !r.tillTime) {
      return null;
    }

    const ret: TimeCullAtomDTO[] = [];

    const fromDTO = new DateTimePartCullAtomDTO();
    fromDTO.type = 'DateTimePartCullAtom';
    fromDTO.operator = ComparisonOperator.GreaterOrEqual;
    fromDTO.part = DateTimePart.DayOfWeek;
    fromDTO.partValue = parseInt(r.from, 10);
    ret.push(fromDTO);

    const tillDTO = new DateTimePartCullAtomDTO();
    tillDTO.type = 'DateTimePartCullAtom';
    tillDTO.operator = ComparisonOperator.LessOrEqual;
    tillDTO.part = DateTimePart.DayOfWeek;
    tillDTO.partValue = parseInt(r.till, 10);
    ret.push(tillDTO);

    const timeDTO = new TimeRangeCullAtomDTO();
    timeDTO.type = 'TimeRangeCullAtom';

    const fromTime = new SbLocalTime(r.fromTime);
    const tillTime = new SbLocalTime(r.tillTime);

    if (fromTime.compareTo(tillTime) === 1) {
      timeDTO.operator = ComparisonOperator.NotIn;
      timeDTO.start = tillTime;
      timeDTO.end = fromTime;
    } else {
      timeDTO.operator = ComparisonOperator.In;
      timeDTO.start = fromTime;
      timeDTO.end = tillTime;
    }

    ret.push(timeDTO);
    return ret;
  }
}

class EasyModeRow {
  from: string;
  till: string;
  fromTime: NgbTimeStruct;
  tillTime: NgbTimeStruct;
}
